import rollbar from '~/vendor/rollbar';

// Branch reducers should be functions
function validateBranchReducers(reducers) {
  return Object.keys(reducers).filter(branch => {
    const reducerType = typeof reducers[branch];
    const isReducerValid = reducerType === 'function';
    if (!isReducerValid) {
      rollbar.warn(
        `Reducers must be functions. The "${branch}" reducer ` +
          `has type "${reducerType}" and will be ignored.`
      );
    }
    return isReducerValid;
  });
}

// Branch state should not return undefined; previous state or null are okay
function validateBranchState(
  branchState,
  action = {},
  branchName = '[unknown branch]'
) {
  if (typeof branchState === 'undefined') {
    rollbar.warn(
      `The "${branchName}" reducer returned undefined while handling action ` +
        `type "${action.type}". If the branch should ignore this action, ` +
        'return the initial state. To unset this branch value, return null.'
    );
  }
}

// All keys on the state object should have a matching reducer
function reduxShapeValidatorFactory(state) {
  const handledBranchMap = Object.keys(state).reduce((map, key) => {
    map[key] = false;
    return map;
  }, {});
  return {
    handleBranch(branch) {
      handledBranchMap[branch] = true;
    },
    validate() {
      const unhandledBranches = Object.keys(handledBranchMap).filter(
        key => !handledBranchMap[key]
      );
      if (unhandledBranches.length) {
        rollbar.warn(
          'The following branches have no corresponding reducer: ' +
            `${unhandledBranches.join(', ')}`
        );
      }
    }
  };
}

/* In the original redux combineReducers there's a thing about testing the
 * reducer with a random action type, but let's just ignore that for now. */

export default function combineReducers(reducers) {
  const branches = validateBranchReducers(reducers);

  return function combinedReducer(state = {}, action) {
    let isDirty = false;
    const reduxShapeValidator = reduxShapeValidatorFactory(state);
    const nextFullState = branches.reduce(
      (nextState, branch) => {
        const initialBranchState = state[branch];
        const nextBranchState = reducers[branch](initialBranchState, action, {
          ...state
        });
        reduxShapeValidator.handleBranch(branch);
        validateBranchState(nextBranchState, action, branch);
        isDirty = isDirty || nextBranchState !== initialBranchState;
        return {
          ...nextState,
          [branch]: isDirty ? nextBranchState : initialBranchState
        };
      },
      {...state}
    );
    reduxShapeValidator.validate();
    return isDirty ? nextFullState : state;
  };
}
